export default __webpack_public_path__ + "static/media/apple_stimuli_phone.1c762575.mp4";